import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userComponent from './user.component';

let userModule = angular.module('user', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('main.user', {
      name: "main.user",
      url: '/user',
      component: 'user',
      data: {protected: true, topMenu:'User Maintenance'}
    });
})

.component('user', userComponent)

.name;

export default userModule;



// WEBPACK FOOTER //
// ./client/app/components/user/user.js